import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGraphView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.5575 9.49828C17.8346 9.80616 17.8096 10.2804 17.5017 10.5575L14.1684 13.5575C13.8832 13.8142 13.4502 13.8142 13.1649 13.5575L10.8889 11.509L7.50172 14.5575C7.19384 14.8346 6.71962 14.8096 6.44253 14.5017C6.16543 14.1938 6.19039 13.7196 6.49828 13.4425L10.3872 9.94253C10.6724 9.68582 11.1054 9.68582 11.3906 9.94253L13.6667 11.991L16.4983 9.44253C16.8062 9.16543 17.2804 9.19039 17.5575 9.49828Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6V18C22 18.5523 21.5523 19 21 19H3C2.44772 19 2 18.5523 2 18V6ZM4 7V17H20V7H4Z"
	})]
});
export default SvgGraphView;
